var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center justify-center chat-count",class:{ 'd-none': this.msgCount == 0 }},[_c('p',[_vm._v(_vm._s(_vm.msgCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }